// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 518) return "js/exportProjectData.b7ad38f6632a148ed9db.js";
	if (chunkId === 240) return "js/240.9145e5b34f84b31ac829.js";
	if (chunkId === 862) return "js/novelExports.f243e6bea75d8073875c.js";
	if (chunkId === 868) return "js/868.66f77f68dc5dcc8c5809.js";
	if (chunkId === 328) return "js/admin.js";
	if (chunkId === 964) return "js/964.ccb9c9cd582ce75131e4.js";
	// return url for filenames based on template
	return undefined;
};